var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', _vm._b({
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "maxWidth": "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'bottom-sheet', {
    title: _vm.title
  }, false), [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('form-tabs', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var prev = _ref.prev,
          next = _ref.next;
        return [_c('tabs-basic', _vm._g(_vm._b({}, 'tabs-basic', {
          value: _vm.form,
          loading: _vm.loading
        }, false), {
          exit: _vm.exit,
          next,
          setLoading: _vm.setLoading,
          input: _vm.setForm
        })), _c('tabs-pages', _vm._g(_vm._b({}, 'tabs-pages', {
          value: _vm.form,
          tab: _vm.tab,
          shows: _vm.shows,
          loading: _vm.loading
        }, false), {
          prev,
          save: _vm.save,
          setLoading: _vm.setLoading,
          input: _vm.setForm
        }))];
      }
    }]),
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  })], 1), _c('client-loader', _vm._b({}, 'client-loader', {
    loading: _vm.loading
  }, false))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }